<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex flex-col sm:flex-row justify-between gap-2 my-3">
  <div class="flex items-center gap-3 my-3">
    <app-back-option-section [loading]="loading"></app-back-option-section>
    <h2>Currency Configuration</h2>
  </div>
  <button *appHasAnyPrivilege="'CURRENCY_CREATE'" nz-button nzType="primary" (click)="editNavigate()">
    Add New Currency
  </button>
</div>

<section id="agent-records">

  <nz-card>
    <div class="flex flex-col gap-3">
      <div [ngClass]="loading ? 'hidden' : 'block'">
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
              <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                  <input type="text" [(ngModel)]="searchText" nz-input placeholder="Search here"/>
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>


              </div>

              <div>
                <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                  Reset Search
                </button>
              </div>

            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>

      <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
        <div class="table-obj">
          <nz-table
            #basicTable [nzData]="agentsData" [nzShowSizeChanger]="pageSize.length > 5"
            [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
            [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
            (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto' }"
            nzOuterBordered class="table-wSpace-nowrap"
          >
            <thead>
            <tr>
              <th>Currency Code</th>
              <th>Currency Name</th>
              <th>LKR Rate</th>
              <th>Active</th>
              <th>
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span></th>
              <th *appHasAnyPrivilege="'CURRENCY_UPDATE,CURRENCY_CHANGE_STATUS'">Actions</th>

            </tr>
            </thead>
            <tbody>

            <!--        Normal Repairs entry-->
            <tr *ngFor="let data of basicTable.data" class="align-baseline">
              <td>
                <span>{{data?.currencyCode}}</span>
              </td>
              <td><span>
                {{ data?.currencyName }}
                <span *ngIf="data?.isBaseCurrency" class="text-primary">(Base Currency)</span>
              </span>
              </td>
              <td>{{ data?.lkrRate }}</td>
              <td >
                <nz-switch [disabled]="data?.isBaseCurrency" [nzSize]="'small'" [disabled]="check('CURRENCY_CHANGE_STATUS')" [ngModel]="data?.active"
                           (ngModelChange)="changeStatus(data?._id, data)"></nz-switch>
              </td>
              <td>{{ data?.createdAt | date:'yyyy-MM-dd' }}</td>
              <td *appHasAnyPrivilege="'CURRENCY_UPDATE'">
                <button [disabled]="data?.isBaseCurrency" [class.outline-button]="!data.isBaseCurrency" class="mr-3" nz-button nzType="default"
                        (click)="editNavigate(this.data)">
                  Edit
                </button>
              </td>
            </tr>

            </tbody>
          </nz-table>
        </div>
      </div>
      <div [ngClass]="loading ? 'block' : 'hidden'">
        <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
      </div>
    </div>
  </nz-card>
</section>

<nz-modal
  [(nzVisible)]="isVisibleCurrencyAddEdit"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancelAddEditCurrency()"
>
  <ng-template
    #modalTitle>{{selectedCurrency ? 'Edit Currency' : 'Add New Currency'}}</ng-template>

  <ng-template #modalContent>
    <div class="flex flex-col gap-4">
      <p class="font-bold">Currency Code :</p>
      <input nz-input type="text" [disabled]="modalType === 'edit'" [(ngModel)]="currencyCode" [maxLength]="15"
             placeHolder="Enter Currency Code"/>

      <p class="font-bold">Currency Name :</p>
      <input nz-input type="text" [(ngModel)]="currencyName"
             [disabled]="modalType === 'edit'"
             placeHolder="Enter Currency Name"/>
      <p class="font-bold">LKR Rate :</p>
      <nz-input-number
        class="w-full"
        [(ngModel)]="lkrRate"
        nzPlaceHolder="Enter LKR Rate"
        [nzMin]="0"
        [nzStep]="1"
      ></nz-input-number>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelAddEditCurrency()">Cancel</button>
    <button nz-button nzType="primary"
            [disabled]="(currencyCode === '' || undefined) || (currencyName === '' || undefined) || (lkrRate === 0 || undefined)"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to save this information?"
            [nzOkText]="'Yes'" [nzCancelText]="'No'"
            (nzOnCancel)="handleCancelAddEditCurrency()"
            (nzOnConfirm)="submitCurrencyData()" [nzLoading]="isLoading">Save
    </button>
  </ng-template>
</nz-modal>
